import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

/**
 * Native App Lifecycle and Navigation Manager
 */
export const NativeApp = {
  isNative: () => Capacitor.isNativePlatform(),

  /**
   * Add listener for Android hardware back button
   * @param {Function} callback Callback with canGoBack status
   */
  onBackButton: (callback) => {
    if (!Capacitor.isNativePlatform()) return { remove: () => {} };
    return App.addListener('backButton', (data) => {
      if (typeof callback === 'function') {
        callback(data);
      }
    });
  },

  /**
   * Add listener for App state change (active vs background)
   * @param {Function} callback
   */
  onStateChange: (callback) => {
    if (!Capacitor.isNativePlatform()) return { remove: () => {} };
    return App.addListener('appStateChange', (state) => {
      if (typeof callback === 'function') {
        callback(state);
      }
    });
  },

  /**
   * Listen to deep links opening the app
   * @param {Function} callback
   */
  onUrlOpen: (callback) => {
    if (!Capacitor.isNativePlatform()) return { remove: () => {} };
    return App.addListener('appUrlOpen', (data) => {
      if (typeof callback === 'function') {
        callback(data);
      }
    });
  },

  /**
   * Minimize or exit the application
   */
  exitApp: async () => {
    if (Capacitor.isNativePlatform()) {
      await App.exitApp();
    }
  },

  /**
   * Get app information (name, version, build)
   */
  getInfo: async () => {
    if (Capacitor.isNativePlatform()) {
      return await App.getInfo();
    }
    return { name: 'NEXDESK', version: '1.0.0', build: '1' };
  }
};

export default NativeApp;
